export default __webpack_public_path__ + "img/sec-3-fg.png";